import React, { useCallback } from 'react';
import { batch, useDispatch } from 'react-redux';

import {
  MenteeModuleStatusSelect,
  setSelectedMenteeModule,
  setUpdateMenteeModuleModalState,
} from 'features/moduleManagement';

function UpdateMenteeModuleStatusSelect({ menteeModule }) {
  const dispatch = useDispatch();
  const { status } = menteeModule;

  const handleOnChange = useCallback(
    (option) => {
      batch(() => {
        dispatch(setUpdateMenteeModuleModalState(true));
        dispatch(
          setSelectedMenteeModule({
            ...menteeModule,
            updatedStatus: option.value,
          })
        );
      });
    },
    [dispatch, menteeModule]
  );
  return (
    <MenteeModuleStatusSelect
      value={{ value: status, label: status }}
      onChange={handleOnChange}
    />
  );
}

export default UpdateMenteeModuleStatusSelect;
